import React from "react";
import {Image} from "semantic-ui-react";

export const Sommerfest = () => {
	return (
		<div id="sommerfest" className="text-center" style={{"background": "#1a3a2a", "paddingTop": "60px", "paddingBottom": "60px"}}>
			<div className="container">
				<div className="section-title">
					<h2 style={{"color": "#FFFFFF"}}>☀️ Sommerfest 2026</h2>
					<p style={{"color": "#CCDDCC", "fontSize": "18px", "maxWidth": "700px", "margin": "0 auto 20px"}}>
						Gør sommerens firmafest eller private selskab uforglemmelig.
						To menuvalg – vælg den stil der passer jeres selskab – <strong style={{"color": "#F5C518"}}>All Inclusive kun 995,- pr. person</strong>.
					</p>
					<div style={{"display": "flex", "gap": "12px", "justifyContent": "center", "flexWrap": "wrap", "marginBottom": "30px"}}>
						<span style={{"background": "#F5C518", "color": "#1a3a2a", "padding": "6px 16px", "borderRadius": "20px", "fontWeight": "bold", "fontSize": "14px"}}>
							✓ Sharing menu
						</span>
						<span style={{"background": "#F5C518", "color": "#1a3a2a", "padding": "6px 16px", "borderRadius": "20px", "fontWeight": "bold", "fontSize": "14px"}}>
							✓ Buffet menu
						</span>
						<span style={{"background": "#F5C518", "color": "#1a3a2a", "padding": "6px 16px", "borderRadius": "20px", "fontWeight": "bold", "fontSize": "14px"}}>
							✓ Fri bar hele aftenen
						</span>
						<span style={{"background": "#F5C518", "color": "#1a3a2a", "padding": "6px 16px", "borderRadius": "20px", "fontWeight": "bold", "fontSize": "14px"}}>
							✓ DJ &amp; dansegulv
						</span>
					</div>
				</div>

				<div className="row" style={{"marginBottom": "20px"}}>
					<div className="col-md-4" style={{"padding": "20px"}}>
						<div style={{"fontSize": "5em"}}>🥗</div>
						<h3 style={{"color": "#FFFFFF"}}>Sharing Menu</h3>
						<p style={{"color": "#CCDDCC"}}>Rimmet laks, kalve tykstegsfilet og hvid chokolademousse – serveret til bordet i hyggelige rammer.</p>
					</div>
					<div className="col-md-4" style={{"padding": "20px"}}>
						<div style={{"fontSize": "5em"}}>🍽️</div>
						<h3 style={{"color": "#FFFFFF"}}>Buffet Menu</h3>
						<p style={{"color": "#CCDDCC"}}>Rig salat-buffet, lune retter med stegt unghane, oksecuvette og svinemørbrad – vælg selv hvad du vil have.</p>
					</div>
					<div className="col-md-4" style={{"padding": "20px"}}>
						<div style={{"fontSize": "5em"}}>🎉</div>
						<h3 style={{"color": "#FFFFFF"}}>Fest hele natten</h3>
						<p style={{"color": "#CCDDCC"}}>Når middagen er slut, overtager DJ'en og dansegulvet. Garderobe og entré til natklubben er inkluderet.</p>
					</div>
				</div>

				<div className="row" style={{"marginTop": "20px"}}>
					<a href='/sommerfest.html' target='_blank' rel='noopener noreferrer'>
						<Image wrapped={true} centered={true} src="/pdf/Haven_Sommerfest_A4-1.png" size="large"
							style={{"borderRadius": "8px", "boxShadow": "0 8px 32px rgba(0,0,0,0.5)", "cursor": "pointer"}}/>
					</a>
					<p style={{"color": "#AABBAA", "marginTop": "12px", "fontSize": "14px"}}>Klik på menuen for at se den i fuld størrelse</p>
				</div>

				<div style={{"marginTop": "30px"}}>
					<a href="#contact" className="btn btn-lg page-scroll"
						style={{"background": "#F5C518", "color": "#1a3a2a", "fontWeight": "bold", "border": "none", "padding": "14px 40px", "fontSize": "18px", "borderRadius": "4px"}}>
						Book sommerfest nu
					</a>
				</div>
			</div>
		</div>
	);
};
